export default __webpack_public_path__ + "static/media/Read-Bold_V3000.e2dbe7ca.woff";